module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAWlBMVEUAAABWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/RWl/Qd6LqaAAAAHXRSTlMAG/OvQyJw/eCsOUxVdx0VD/rWsogGA+nGXZlnv2iUMEIAAACuSURBVBjTZZHZEoMgDEWvKJRNEXdt8/+/WWPGVsfzwnAISy5gtHGWdmxfawhNSRf6hl2h6IZi6yjHSnBSCxRE3QThLbUahoeXQIKBO6Sa5/knS9jndot9Oa8xVFWIsSQBdOUplyEUejhkFtM1ENraEizZhW3VJu1HMAmOPJKRVj8iwY83E8a4ucHjRPOBHnekpa2VW/wain90qg61JK3SYW8hl1x5fkfmpp3RPP8CyIsYw2Ymn9wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_delegate_s.png
// module id = bR5z
// module chunks = 15